// removed by extract-text-webpack-plugin
module.exports = {"App":"intro__App__1tNGO","VrcLogo":"intro__VrcLogo__28bil","Trailer":"intro__Trailer__1i2yR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Intro/intro.css
// module id = 233
// module chunks = 8